<!-- eslint-disable max-len -->
<template>
  <div class="ac-create-order ac-card-content">
    <div class="ac-header-container just-start">
      <button type="button" class="ac-close-button" @click="close">
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        />
      </button>
      <div class="ac-header">Review Customers</div>
    </div>
    <div class="ac-body-container">
      <span>
        <b>
          We’ve processed your file and
          {{ members.filter((obj) => !obj.notInvite).length }}
          member{{
            members.filter((obj) => !obj.notInvite).length > 1 ? 's' : ''
          }}
          will be invited.
        </b>
        <br />
        <br />
        Uncheck anyone you don’t want to invite, and choose the Connect
        SmartMaintenance plan you'd like to offer them.
        <b
          >Invites will be sent to selected customers via email once you
          confirm.</b
        >
        <br />
        <br />
        Please ensure all required fields are completed and properly formatted
        in the file — <b>only fully completed entries can be invited.</b>
      </span>
      <div
        v-if="
          Object.keys(parsingErrorObj).length > 0 &&
          members.filter((obj) => obj.notInvite).length === 0
        "
        class="error-container"
      >
        <span
          >{{ Object.keys(parsingErrorObj).length }} Errors Stopped Members from
          Importing. &nbsp;</span
        >
        <span>Please fix errors below and import .CSV again.</span>
      </div>
      <div
        v-else-if="members.filter((obj) => obj.notInvite).length > 0"
        class="invite-container"
      >
        {{
          members.filter((obj) => obj.notInvite).length > 1
            ? ` ${members.filter((obj) => obj.notInvite).length} Members will not
        be Imported.`
            : ` ${
                members.filter((obj) => obj.notInvite).length
              } Member will not be Imported.`
        }}
      </div>
      <div class="ac-input-container">
        <div class="ac-input-header">Select preferred Smart Maintenance® plan. </div>
        <SACDropdown
          class="margin-bottom"
          :options="providerPlansOptions"
          :value="providerPlanId"
          placeholder="Select Plan"
          field="providerPlanId"
          :change="change"
          :error="parsingErrorObj.providerPlanErr"
        />
      </div>
      <div class="table-container table-header">
        <span> </span>
        <span>First Name</span>
        <span>Last Name</span>
        <span>Email</span>
        <span>Phone</span>
        <span>Address1</span>
        <span>Address2</span>
        <span>City</span>
        <span>State</span>
        <span>Postal Code</span>
        <span>Country</span>
      </div>
      <div class="scroll-view">
        <div v-for="(s, idx) in members" :key="idx" class="order-row-container">
          <div class="o-flex-container flex-column">
            <div class="flex-column margin-top-4">
              <div class="table-container">
                <div class="tb-item">
                  <div class="tb-sub-item">
                    <SACCheckbox
                      :checked="!s.notInvite && Object.keys(s.error).length === 0"
                      :change="() => changeMemberInvite(idx)"
                    />
                  </div>
                </div>
                <div class="tb-item">
                  <SACInput
                    :id="`firstName-${idx}`"
                    type="text"
                    field="firstName"
                    :value="s.firstName"
                    :error="s.error['firstName']"
                    :change="(f, v) => changeMemberInfo(f, v, idx)"
                    :isV2="true"
                  />
                </div>
                <div class="tb-item">
                  <SACInput
                    :id="`lastName-${idx}`"
                    type="text"
                    field="lastName"
                    :value="s.lastName"
                    :error="s.error['lastName']"
                    :change="(f, v) => changeMemberInfo(f, v, idx)"
                    :isV2="true"
                  />
                </div>
                <div class="tb-item">
                  <SACInput
                    :id="`email-${idx}`"
                    type="text"
                    field="email"
                    :value="s.email"
                    :error="s.error['email']"
                    :change="(f, v) => changeMemberInfo(f, v, idx)"
                    :isV2="true"
                  />
                </div>
                <div class="tb-item">
                  <SACInput
                    :id="`phone-${idx}`"
                    type="number"
                    field="phone"
                    restrict="phone-number"
                    :value="s.phone"
                    :error="s.error['phone']"
                    :change="(f, v) => changeMemberInfo(f, v, idx)"
                    :isV2="true"
                  />
                </div>
                <div class="tb-item">
                  <SACInput
                    :id="`address1-${idx}`"
                    type="number"
                    field="address1"
                    :value="s.address1"
                    :error="s.error['address1']"
                    :change="(f, v) => changeMemberInfo(f, v, idx)"
                    :isV2="true"
                  />
                </div>
                <div class="tb-item">
                  <SACInput
                    :id="`address2-${idx}`"
                    type="number"
                    field="address2"
                    restrict="phone-number"
                    :value="s.address2"
                    :error="s.error['address2']"
                    :change="(f, v) => changeMemberInfo(f, v, idx)"
                    :isV2="true"
                  />
                </div>
                <div class="tb-item">
                  <SACInput
                    :id="`city-${idx}`"
                    type="number"
                    field="city"
                    :value="s.city"
                    :error="s.error['city']"
                    :change="(f, v) => changeMemberInfo(f, v, idx)"
                    :isV2="true"
                  />
                </div>
                <div class="tb-item">
                  <SACInput
                    :id="`state-${idx}`"
                    type="number"
                    field="state"
                    :value="s.state"
                    :error="s.error['state']"
                    :change="(f, v) => changeMemberInfo(f, v, idx)"
                    :isV2="true"
                  />
                </div>
                <div class="tb-item">
                  <SACInput
                    :id="`postalCode-${idx}`"
                    type="number"
                    field="state"
                    :value="s.postalCode"
                    :error="s.error['postalCode']"
                    :change="(f, v) => changeMemberInfo(f, v, idx)"
                    :isV2="true"
                  />
                </div>
                <div class="tb-item">
                  <SACInput
                    :id="`country-${idx}`"
                    type="number"
                    field="state"
                    :value="s.country"
                    :error="s.error['country']"
                    :change="(f, v) => changeMemberInfo(f, v, idx)"
                    :isV2="true"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ac-footer-container">
      <button type="button" class="ac-form-button" @click="close">
        Cancel
      </button>
      <button
        type="button"
        class="ac-form-button"
        :disabled="invite"
        @click="createBatchmembers"
      >
        Send Invite
      </button>
    </div>
    <ProcessOverlay :show="processing" />
  </div>
</template>

<script>
import customerMixin from '@shared/mixins/customerMixin';
import SACInput from '@shared/components/sac/SACInput.vue';
import SACCheckbox from '@shared/components/sac/SACCheckbox.vue';
import SACDropdown from '@shared/components/sac/SACDropdown.vue';
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';
import formatPhoneNumber from '@shared/lib/formatter/formatPhoneNumber';

import phoneValidation from '@shared/lib/errorCatch/phoneValidation';
import emailValidation from '@shared/lib/errorCatch/emailValidation';

export default {
  name: 'ReviewCsvMember',
  components: {
    SACInput,
    SACCheckbox,
    SACDropdown,
    ProcessOverlay,
  },
  mixins: [customerMixin],
  data() {
    return {
      members: [],
      processing: false,
      invite: false,
      providerPlanId: 0,
      providerPlansOptions: [],
    };
  },
  mounted() {
    this.$store.dispatch('getProviderPlans', { corpId: Math.abs(this.adminCorp) });
    if (this.newCustomersUpload.length > 0) {
      this.mapMembers();
    }
  },
  watch: {
    providerPlans(nv) {
      const appOnlyPlans = nv.filter((p) => (
        p.planType === 'AppOnly' && p.priceInitial === 0 && (p.bonusFilterVoucher > 0 || p.bonusComfortCredit > 0)
      )).map((plan) => ({
          label: plan.name,
          value: plan.planId,
        }));
      this.providerPlansOptions = appOnlyPlans;
      this.providerPlanId = appOnlyPlans.length >= 1 ? appOnlyPlans[0].value : null;
    },
  },
  methods: {
    close() {
      this.$store.dispatch('changeCustomerValues', [
        {
          field: 'showActionModal',
          value: false,
        },
      ]);
    },
    mapMembers(members) {
      let errorObj = {};
      const allEmails = (members ?? this.newCustomersUpload).map((c) => c.email.toLowerCase());
      const allPhone = (members ?? this.newCustomersUpload).map((c) => c.phone?.replace(/\D/g, ""));
      const membersMapped = (members ?? this.newCustomersUpload).map(
        (p, idx) => {
          let member = {
            ...p,
            // notInvite: false,
            phone: formatPhoneNumber(p.phone),
          };
          let error = {};
          let notInvite = p.notInvite || false;
          if (!p.firstName) {
            error['firstName'] = 'First name is missing';
            notInvite = true;
          }
          if (!p.lastName) {
            error['lastName'] = 'Last name is missing';
            notInvite = true;
          }
          if (!p.phone) {
            error['phone'] = 'Phone is missing';
            notInvite = true;
          } else if (!phoneValidation(p.phone)) {
            error['phone'] = 'Phone is not valid';
            notInvite = true;
          } else if (allPhone.indexOf(p.phone?.replace(/\D/g, "")) !== idx) {
            error['phone'] = 'Duplicate number';
            notInvite = true;
          }
          if (!p.email) {
            error['email'] = 'Email is required';
            notInvite = true;
          } else if (!emailValidation(p.email)) {
            error['email'] = 'Email is not valid';
            notInvite = true;
          } else if (allEmails.indexOf(p.email.toLowerCase()) !== idx) {
            error['email'] = 'Duplicate email';
            notInvite = true;
          }
          if (!p.address1) {
            error['address1'] = 'Address 1 is missing';
            notInvite = true;
          }
          if (!p.city) {
            error['city'] = 'City is missing';
            notInvite = true;
          }
          if (!p.state) {
            error['state'] = 'State is missing';
            notInvite = true;
          }
          if (!p.postalCode) {
            error['postalCode'] = 'Postal Code / Zip Code is missing';
            notInvite = true;
          }
          if (!p.country) {
            error['country'] = 'Country is missing';
            notInvite = true;
          }
          member.notInvite = notInvite;
          member.error = error;
          return member;
        }
      );
      if (members && this.providerPlanId === 0) {
        errorObj.providerPlanErr = 'Select Provider Plan';
      }
      this.$store.dispatch('changeCustomerValues', [
        {
          field: 'parsingErrorObj',
          value: errorObj,
        },
      ]);
      this.members = membersMapped;
    },
    async createBatchmembers() {
      if (
        Object.keys(this.parsingErrorObj).length === 0 &&
        this.providerPlanId !== 0
      ) {
        try {
          const custMapped = this.members.filter((obj) => !obj.notInvite);
          if (custMapped.length > 0) {
            this.invite = false;
            this.processing = true;
            const res = await this.$store.dispatch('batchMembers', {
              members: custMapped,
              providerPlanId: this.providerPlanId,
            });
            if (res) {
              await this.$store.dispatch('getTechnicianList');
            }
            if (Object.keys(this.parsingErrorObj).length === 0) {
              this.close();
            }
            this.$store.dispatch('getAllCustomers');
          } else {
            this.invite = true;
          }
        } catch (err) {
          console.error(err);
        }
      }
      this.processing = false;
    },
    changeMemberInfo(field, value, idx) {
      if (field === 'phone') {
        value = formatPhoneNumber(value);
      }
      const nTech = this.members.slice();
      nTech[idx] = {
        ...nTech[idx],
        [field]: value,
      };
      this.mapMembers(nTech);
    },
    changeMemberInvite(idx) {
      const nTech = this.members.slice();
      nTech[idx].notInvite = !nTech[idx].notInvite;
      this.mapMembers(nTech);

      const custMapped = this.members.filter((obj) => !obj.notInvite);
      this.invite = !(custMapped.length > 0);
    },
    change(f, v) {
      this[f] = v;
      if (f === 'providerPlanId') {
        let errorObj = {};
        Object.keys(this.parsingErrorObj).map((e) => {
          if (e !== 'providerPlanErr') {
            errorObj[e] = this.parsingErrorObj[e];
          }
        });
        this.$store.dispatch('changeCustomerValues', [
          {
            field: 'parsingErrorObj',
            value: errorObj,
          },
        ]);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.table-container {
  display: grid;
  grid-template-columns: 0.5fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr auto;
}
.table-header {
  background-color: #121830;
  padding-top: 5px;
  padding-bottom: 5px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  span {
    color: white;
  }
}
.order-row-container {
  border-left: $GRAY_80 0.5px solid;
  border-right: $GRAY_80 0.5px solid;
}
.order-row-container:last-child {
  border-bottom: $GRAY_80 0.5px solid;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.tb-sub-item:first-child {
  padding-left: 10px;
  padding-top: 10px;
}
.tb-item {
  width: 98%;
}

.error-container {
  align-items: flex-start;
  background-color: #fbd6d4;
  display: flex;
  height: 37px;
  padding: 9px 25px;
  margin-bottom: 13px;

  span {
    color: rgba(43, 55, 87, 1);
    font-weight: 400;
  }

  span:nth-of-type(1) {
    color: rgba(43, 55, 87, 1);
    font-weight: bold;
  }
}

.invite-container {
  align-items: flex-start;
  background-color: #becdf7;
  display: flex;
  height: 37px;
  padding: 9px 25px;
  margin-bottom: 13px;
  color: rgba(43, 55, 87, 1);
  font-weight: bold;
}

.info-item {
  color: black;
  height: 23px;
  padding: 30px 0px;
}

.reupload-button {
  color: rgba(73, 121, 255, 1);
  font-weight: 500;
  height: 23px;
  text-decoration: underline;
  padding: 0px 0px 50px 0px;
  width: 100px;
  cursor: pointer;
}

.ac-footer-container {
  display: flex;
  justify-content: flex-start;

  .f-button {
    background-color: $N50;
    border-radius: 8px;
    color: white;
    padding: 12px 18px;
    font-weight: 500;

    &.blue {
      background-color: $NBLUE100;
    }

    &:disabled {
      opacity: 0.5;
      pointer-events: none;
    }
  }
}
</style>
